/* istanbul ignore next: dynamic import */
var headerCta = function headerCta() {
  return import(
  /* webpackChunkName: 'headerCta' */
  './Templates/headerCta');
},
    promoAnonymousCta = function promoAnonymousCta() {
  return import(
  /* webpackChunkName: 'promoAnonymousCta' */
  './Templates/promoAnonymousCta');
},
    promoKnownCta = function promoKnownCta() {
  return import(
  /* webpackChunkName: 'promoKnownCta' */
  './Templates/promoKnownCta');
},
    standardAnonymousCta = function standardAnonymousCta() {
  return import(
  /* webpackChunkName: 'standardAnonymousCta' */
  './Templates/standardAnonymousCta');
},
    standardKnownCta = function standardKnownCta() {
  return import(
  /* webpackChunkName: 'standardKnownCta' */
  './Templates/standardKnownCta');
},
    interstitialAnonymousCta = function interstitialAnonymousCta() {
  return import(
  /* webpackChunkName: 'interstitialAnonymous' */
  './Templates/interstitialAnonymousCta');
},
    floatingAnonymousCta = function floatingAnonymousCta() {
  return import(
  /* webpackChunkName: 'floatingAnonymousCta' */
  './Templates/floatingAnonymousCta');
};

export default {
  data: function data() {
    return {
      ctaType: '',
      config: {},
      styleOverrides: {}
    };
  },
  components: {
    'Header': headerCta,
    'PromoAnonymous': promoAnonymousCta,
    'PromoKnown': promoKnownCta,
    'StandardAnonymous': standardAnonymousCta,
    'StandardKnown': standardKnownCta,
    'InterstitialAnonymous': interstitialAnonymousCta,
    'FloatingAnonymous': floatingAnonymousCta
  },
  computed: {
    containerStyleOverrides: function containerStyleOverrides() {
      return this.config.settings && this.config.settings.location === 'Footer' ? null : this.styleOverrides;
    }
  },
  methods: {
    init: function init(config) {
      if (config && config.settings) {
        this.ctaType = config.settings.ctaType;
        this.config = config;
      }
    },
    setStyleOverrides: function setStyleOverrides(overrides) {
      var _this = this;

      if (overrides) {
        if (overrides.backgroundColor) {
          // background color
          this.$set(this.styleOverrides, 'backgroundColor', overrides.backgroundColor);
        }

        if (overrides.smallBackgroundImageUrl || overrides.largeBackgroundImageUrl || overrides.patternImageUrl) {
          // image
          this.$_setBackgroundImage(overrides.smallBackgroundImageUrl, overrides.largeBackgroundImageUrl, overrides.patternImageUrl);

          if (overrides.smallBackgroundImageUrl || overrides.largeBackgroundImageUrl) {
            // respond to window resizing if we have a small or large background image
            window.addEventListener('resize', function () {
              _this.$_setBackgroundImage(overrides.smallBackgroundImageUrl, overrides.largeBackgroundImageUrl, overrides.patternImageUrl);
            });
          }
        }
      }
    },
    $_setBackgroundImage: function $_setBackgroundImage(smallImg, largeImg, patternImg) {
      if (this.$el.clientWidth < 767 && smallImg) {
        this.$_setImageStyles(smallImg);
      } else if (this.$el.clientWidth >= 767 && largeImg) {
        this.$_setImageStyles(largeImg);
      } else {
        this.$_setImageStyles(patternImg);
      }
    },
    $_setImageStyles: function $_setImageStyles(imgUrl, backgroundSize) {
      if (imgUrl) {
        this.$set(this.styleOverrides, 'backgroundImage', "url('" + imgUrl + "')");
      } else {
        this.$delete(this.styleOverrides, 'backgroundImage');
      }
    }
  }
};